export const PRODUCT_SUGG_PRODUCTS = "store/productSuggestions/PRODUCTS";
export const PRODUCT_SUGG_PRODUCTS_COMPLETED = "store/productSuggestions/PRODUCTS_COMPLETED";
export const PRODUCT_SUGG_PRODUCTS_FAILED = "store/productSuggestions/PRODUCTS_FAILED";

export const PRODUCT_SUGG_LIST = "store/productSuggestions/LIST";
export const PRODUCT_SUGG_LIST_COMPLETED = "store/productSuggestions/LIST_COMPLETED";
export const PRODUCT_SUGG_LIST_FAILED = "store/productSuggestions/LIST_FAILED";

export const PRODUCT_SUGG_INGREDIENTS = "store/productSuggestions/INGREDIENTS";
export const PRODUCT_SUGG_INGREDIENTS_COMPLETED = "store/productSuggestions/INGREDIENTS_COMPLETED";
export const PRODUCT_SUGG_INGREDIENTS_FAILED = "store/productSuggestions/INGREDIENTS_FAILED";

export const PRODUCT_SUGG_PICTOS = "store/productSuggestions/PICTOS";
export const PRODUCT_SUGG_PICTOS_COMPLETED = "store/productSuggestions/PICTOS_COMPLETED";
export const PRODUCT_SUGG_PICTOS_FAILED = "store/productSuggestions/PICTOS_FAILED";

export const PRODUCT_SUGG_CREATE = "store/productSuggestions/CREATE";
export const PRODUCT_SUGG_CREATE_COMPLETED = "store/productSuggestions/CREATE_COMPLETED";
export const PRODUCT_SUGG_CREATE_FAILED = "store/productSuggestions/CREATE_FAILED";

export const PRODUCT_SUGG_UPDATE = "store/productSuggestions/UPDATE";
export const PRODUCT_SUGG_UPDATE_COMPLETED = "store/productSuggestions/UPDATE_COMPLETED";
export const PRODUCT_SUGG_UPDATE_FAILED = "store/productSuggestions/UPDATE_FAILED";

export const PRODUCT_SUGG_DELETE = "store/productSuggestions/DELETE";
export const PRODUCT_SUGG_DELETE_COMPLETED = "store/productSuggestions/DELETE_COMPLETED";
export const PRODUCT_SUGG_DELETE_FAILED = "store/productSuggestions/DELETE_FAILED";
